'use client';

import {cn} from '@/lib/utils';
import {useTranslations} from 'next-intl';
import {useEffect, useState} from 'react';

export default function ScrollTopBtn() {
  const [showBtn, setShowBtn] = useState(false);
  const [isOnRedBg, setIsOnRedBg] = useState(false);
  let lastScrollY = 0;

  const t = useTranslations('Navigation');
  // if already top of page, don't show button
  const handleScroll = () => {
    const body = document.body;
    const html = document.documentElement;
    const documentHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    const scrollBtnTop = document
      .getElementById('scroll-top-btn')
      ?.getBoundingClientRect().top;

    if (window.scrollY + (scrollBtnTop ?? 0) > documentHeight - 280) {
      setIsOnRedBg(true);
      setShowBtn(true);
    } else {
      setIsOnRedBg(false);
      setShowBtn(window.scrollY > 100 && window.scrollY < lastScrollY);
      lastScrollY = window.scrollY;
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="fixed z-50 bottom-20 right-10 common-layout">
      <button
        onClick={() => {
          window.scrollTo({top: 0, behavior: 'smooth'});
          document.getElementById('site-logo')?.focus();
        }}
        id="scroll-top-btn"
        role="button"
        className={cn(
          'bg-[#e22319] text-xs rounded-full  shadow-lg',
          'transition-all duration-300 ease-in-out',
          'cursor-pointer hover:bg-white hover:text-[#e22319]',
          showBtn ? '' : 'opacity-0 pointer-events-none',
          !isOnRedBg ? 'bg-[#e22319] text-white' : 'bg-white text-[#e22319]'
        )}
      >
        <div className="flex items-center justify-center py-2 px-2">
          <span className="material-symbols outlined">keyboard_arrow_up</span>
          {/* {t('top')} */}
        </div>
      </button>
    </div>
  );
}
